<div class="account-pages my-5 pt-5">
  <div class="container">
    <!-- Step Progress Indicator -->
    <div class="row justify-content-center mb-4">
      <div class="col-lg-10">
        <div class="card shadow-sm border-0" style="background: linear-gradient(135deg, #556ee6 0%, #6c81ec 100%);">
          <div class="card-body py-3 px-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <small class="text-white-50 text-uppercase fw-semibold">Onboarding Progress</small>
                <h6 class="mb-0 mt-1">
                  <span class="text-white">Step {{ currentStep }} </span>
                  <span class="text-white">of {{ totalSteps }}</span>
                </h6>
              </div>
              <div class="text-end">
                <span class="badge bg-white text-primary font-size-12 px-3 py-2">
                  <i class="bx bx-sync me-1"></i> Setting Up
                </span>
              </div>
            </div>
            <div class="progress" style="height: 8px; border-radius: 10px; background-color: rgba(255, 255, 255, 0.2);">
              <div class="progress-bar bg-white" 
                   role="progressbar" 
                   [style.width.%]="progressPercentage"
                   [attr.aria-valuenow]="progressPercentage" 
                   aria-valuemin="0" 
                   aria-valuemax="100"
                   style="border-radius: 10px; transition: width 0.6s ease;">
              </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <small class="text-white-50">
                <i class="bx bx-loader bx-spin me-1"></i>Planning Center Connection
              </small>
              <small class="text-white-50 font-size-11">{{ progressPercentage }}% Complete</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <!-- Main Setup Card -->
      <div class="col-lg-6">
        <div class="card overflow-hidden">
          <div class="bg-primary">
            <div class="text-primary text-center p-4">
              <div class="d-flex align-items-center justify-content-center">
                <i class="bx bx-sync font-size-32 text-white me-3"></i>
                <div class="text-start">
                  <h5 class="text-white font-size-20 mb-1">Connect Planning Center</h5>
                  <p class="text-white-50 mb-0">Enable real-time synchronization</p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body p-4">
            <div class="p-3">
              <div class="text-center mb-4">
                <div class="avatar-lg mx-auto mb-3">
                  <div class="avatar-title bg-soft-primary text-primary rounded-circle">
                    <i class="bx bx-sync font-size-24"></i>
                  </div>
                </div>
                <h5 class="mb-2">Real-Time Data Sync</h5>
                <p class="text-muted mb-0">
                  Echo will set up webhooks with Planning Center to automatically receive updates as they happen. 
                  This ensures your data is always current without manual refreshing.
                </p>
              </div>

              <div class="mb-4">
                <h6 class="mb-3">
                  <i class="bx bx-list-check text-primary me-2"></i>
                  We'll sync the following:
                </h6>
                <div class="row g-3">
                  <div *ngFor="let webhook of webhookTypes; let i = index" class="col-12">
                    <div class="card border mb-0 webhook-card">
                      <div class="card-body p-3">
                        <div class="d-flex align-items-start">
                          <div class="flex-shrink-0 me-3">
                            <div class="avatar-sm">
                              <div class="avatar-title bg-soft-primary text-primary rounded">
                                <i class="bx {{webhook.icon}} font-size-20"></i>
                              </div>
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <h6 class="mb-1 font-size-15">{{webhook.name}}</h6>
                            <p class="text-muted mb-0 font-size-13">{{webhook.description}}</p>
                          </div>
                          <div class="flex-shrink-0 ms-2">
                            <i class="bx bx-check-circle font-size-20 text-success"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="alert alert-info border-0 shadow-sm" role="alert">
                <div class="d-flex align-items-start">
                  <div class="flex-shrink-0 me-3">
                    <i class="bx bx-info-circle font-size-20"></i>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-1 font-size-14">Administrator Access Required</h6>
                    <p class="mb-0 font-size-13">
                      Echo needs permission to create webhooks in your Planning Center account. 
                      Make sure you're logged in as a account administrator.
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-grid">
                <button 
                  type="button" 
                  class="btn btn-primary btn-lg waves-effect waves-light shadow-sm"
                  (click)="setupWebhooks()"
                  [disabled]="isLoading"
                  style="padding: 12px; font-size: 16px;">
                  <span *ngIf="!isLoading">
                    <i class="bx bx-link-alt me-2 font-size-18"></i>
                    <span class="fw-semibold">Connect Webhooks Now</span>
                  </span>
                  <span *ngIf="isLoading">
                    <i class="bx bx-loader bx-spin me-2"></i> Setting up webhooks...
                  </span>
                </button>
              </div>

              <div *ngIf="statusMessage" class="mt-3">
                <div class="alert alert-light border d-flex align-items-center py-3 mb-0 shadow-sm" role="alert">
                  <div class="flex-shrink-0 me-3">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <span class="text-muted font-size-14">{{ statusMessage }}</span>
                  </div>
                </div>
              </div>

              <div *ngIf="!statusMessage" class="mt-3 text-center">
                <p class="text-muted mb-0 font-size-13">
                  <i class="bx bx-shield-alt me-1"></i>
                  Webhooks are required for Echo to function properly
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Help & FAQ Section -->
      <div class="col-lg-6">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="d-flex align-items-center mb-4">
              <div class="avatar-sm me-3">
                <div class="avatar-title bg-soft-primary text-primary rounded">
                  <i class="bx bx-help-circle font-size-20"></i>
                </div>
              </div>
              <div>
                <h5 class="mb-0">Help & FAQ</h5>
                <small class="text-muted">Common questions answered</small>
              </div>
            </div>

            <div class="accordion" id="webhookFaqAccordion">
              <div class="accordion-item">
                <h2 class="accordion-header" id="faqHeading1">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 0" type="button" (click)="toggleFaq(0)">
                    <i class="bx bx-help-circle text-primary me-2"></i>
                    Why do I need webhooks?
                  </button>
                </h2>
                <div id="faqCollapse1" class="accordion-collapse collapse" [class.show]="openFaqIndex === 0">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      Webhooks allow Echo to receive instant notifications when data changes in Planning Center. 
                      Without webhooks, you'd have to manually refresh data, and automated features like WhatsApp 
                      notifications wouldn't work.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="faqHeading2">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 1" type="button" (click)="toggleFaq(1)">
                    <i class="bx bx-shield-alt text-success me-2"></i>
                    Is my data secure?
                  </button>
                </h2>
                <div id="faqCollapse2" class="accordion-collapse collapse" [class.show]="openFaqIndex === 1">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-3">
                      Absolutely. Echo takes data security seriously and implements multiple layers of protection:
                    </p>
                    <ul class="text-muted font-size-14 mb-0">
                      <li class="mb-2"><strong>AES 256-bit encryption:</strong> All sensitive data is encrypted at rest using industry-leading encryption standards</li>
                      <li class="mb-2"><strong>TLS/SSL encryption:</strong> All data transmitted between your browser, our servers, and Planning Center uses secure HTTPS connections</li>
                      <li class="mb-2"><strong>Cloud KMS:</strong> API tokens and credentials are stored using a secure Cloud Key Management Service</li>
                      <li class="mb-2"><strong>Webhook verification:</strong> All incoming webhooks are cryptographically signed and verified to prevent unauthorized access</li>
                      <li class="mb-0"><strong>Compliance:</strong> We follow industry best practices and Planning Center's security guidelines</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="faqHeading3">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 2" type="button" (click)="toggleFaq(2)">
                    <i class="bx bx-unlink text-warning me-2"></i>
                    Can I disconnect webhooks later?
                  </button>
                </h2>
                <div id="faqCollapse3" class="accordion-collapse collapse" [class.show]="openFaqIndex === 2">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      Absolutely. You can manage or disconnect your webhooks at any time from the Organization 
                      Settings page. However, disconnecting will disable real-time sync and automation features.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="faqHeading4">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 3" type="button" (click)="toggleFaq(3)">
                    <i class="bx bx-lock-alt text-info me-2"></i>
                    What permissions are required?
                  </button>
                </h2>
                <div id="faqCollapse4" class="accordion-collapse collapse" [class.show]="openFaqIndex === 3">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      You must be logged in as a Planning Center account administrator to create webhooks. 
                      This ensures that only authorized personnel can enable data synchronization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
